import { assignSafe } from "@summit/core";

export class BackEndClientAction {
  //Crud tasks
  api: string;
  id: string;
  filter: string;

  constructor(jsonData?: Partial<BackEndClientAction>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
